import { currencyConstants } from '../constants';

const initialState = {
    currency: null,

    fetchingCurrency: false,
    fetchingCurrencyError: null,

    creatingCurrency: false,
    creatingCurrencyError: null,

    updatingCurrency: false,
    updatingCurrencyError: null,

    deletingCurrency: false,
    deletingCurrencyError: null,

    loading: false,
    error: null,
    currency: [],
};

export function currency(state = initialState, action) {
    switch (action.type) {
        case currencyConstants.GET_CURRENCY_REQUEST: {
            return {
                ...state,
                fetchingCurrency: true,
                currency: null,
                fetchingCurrencyError: null,
            };
        }
        case currencyConstants.GET_CURRENCY_SUCCESS: {
            return {
                ...state,
                fetchingCurrency: false,
                currency: action.currency,
                fetchingCurrencyError: null,
            };
        }
        case currencyConstants.GET_CURRENCY_FAILURE: {
            return {
                ...state,
                fetchingCurrency: false,
                fetchingCurrencyError: action.error,
            };
        }

        case currencyConstants.CREATE_CURRENCY_REQUEST: {
            return {
                ...state,
                creatingCurrency: true,
                creatingCurrencyError: false,
            };
        }
        case currencyConstants.CREATE_CURRENCY_SUCCES: {
            return {
                ...state,
                creatingCurrency: false,
                currency: action.currency,
                creatingCurrencyError: false,
            };
        }
        case currencyConstants.CREATE_CURRENCY_FAILURE: {
            return {
                ...state,
                creatingCurrency: false,
                creatingCurrencyError: action.error,
            };
        }

        case currencyConstants.UPDATE_CURRENCY_REQUEST: {
            return {
                ...state,
                updatingCurrency: true,
                updatingCurrencyError: false,
            };
        }
        case currencyConstants.UPDATE_CURRENCY_SUCCESS: {
            return {
                ...state,
                updatingCurrency: false,
                currency: action.currency,
                updatingCurrencyError: false,
            };
        }
        case currencyConstants.UPDATE_CURRENCY_FAILURE: {
            return {
                ...state,
                updatingCurrency: false,
                updatingCurrencyError: action.error,
            };
        }

        case currencyConstants.DELETE_CURRENCY_REQUEST: {
            return {
                ...state,
                deletingCurrency: true,
                deletingCurrencyError: false,
                deleteCurrencyBlockedBy: null,
            };
        }
        case currencyConstants.DELETE_CURRENCY_SUCCESS: {
            return {
                ...state,
                deletingCurrency: false,
                currency: action.currency,
                deletingCurrencyError: false,
                deleteCurrencyBlockedBy: null,
            };
        }
        case currencyConstants.DELETE_CURRENCY_FAILURE: {
            return {
                ...state,
                deletingCurrency: false,
                deletingCurrencyError: action.error,
            };
        }

        case currencyConstants.DELETE_CURRENCY_BLOCKED:
            return { 
                ...state, 
                deletingCurrency: false, 
                deleteCurrencyBlockedBy: action.scenarios 
            };

        case currencyConstants.LOAD_CURRENCIES_REQUEST: {
            return { 
                ...state, 
                loading: true, 
                error: null 
            };
        }
        
        case currencyConstants.LOAD_CURRENCIES_SUCCESS: {
            return { 
                ...state, 
                loading: false, 
                currency: Array.isArray(action.currencies) ? action.currencies : [] 
            };
        }
        
        case currencyConstants.LOAD_CURRENCIES_FAILURE: {
            return { 
                ...state, 
                loading: false, 
                error: action.error
            };
        }

        default: {
            return state;
        }
    }
}
 